import PageHero from '@/components/sections/shared/PageHero'
import { useData } from '@/hooks/useLocale'

/** The Updates page's photo hero, with a badge naming the latest release. */
export default function UpdatesHeroSection() {
  const { UPDATES } = useData()
  const [latest] = UPDATES.releases

  return (
    <PageHero eyebrow={UPDATES.eyebrow} title={UPDATES.title} text={UPDATES.text}>
      <div className="flex flex-wrap items-center gap-3 pt-1.5">
        <span className="flex h-[34px] items-center rounded-full bg-white/14 px-3.5 text-[13px] font-semibold inset-ring inset-ring-white/22">
          {latest ? (
            <span>
              {UPDATES.latest}: <span dir="ltr">{latest.version}</span> ·{' '}
              {latest.date}
            </span>
          ) : (
            UPDATES.soon
          )}
        </span>
      </div>
    </PageHero>
  )
}
